/* FRESCALI — Interaktionen */

(() => {
  /* ===== Zeitlich begrenzte Elemente (data-end) =====
     Alles mit data-end="ISO-Datum" verschwindet nach diesem Zeitpunkt von selbst,
     auch wenn das Theme nicht neu veröffentlicht wird. */
  document.querySelectorAll('[data-end]').forEach((el) => {
    const end = Date.parse(el.dataset.end);
    if (!isNaN(end) && Date.now() > end) el.remove();
  });

  /* ===== Sanftes Einblenden beim Scrollen =====
     Alles, was beim Laden schon (fast) im Bild ist, wird sofort gezeigt;
     der Rest beim Scrollen. Sicherheitsnetz: nach 2 s ist alles sichtbar. */
  const reveals = Array.from(document.querySelectorAll('.reveal'));
  const showAll = () => reveals.forEach((el) => el.classList.add('is-visible'));

  if (reveals.length) {
    const vh = window.innerHeight || document.documentElement.clientHeight;
    reveals.forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < vh * 1.3) el.classList.add('is-visible');
    });

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.01, rootMargin: '0px 0px 25% 0px' }
      );
      reveals.forEach((el) => { if (!el.classList.contains('is-visible')) io.observe(el); });
    } else {
      showAll();
    }
    setTimeout(showAll, 2000);
  }

  /* ===== Hamburger / Menü (Telefon) ===== */
  const hamburger = document.querySelector('[data-hamburger]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const body = document.body;

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      const isOpen = hamburger.classList.toggle('is-open');
      mobileMenu.classList.toggle('is-open', isOpen);
      body.classList.toggle('no-scroll', isOpen);
      hamburger.setAttribute('aria-expanded', String(isOpen));
      mobileMenu.setAttribute('aria-hidden', String(!isOpen));
    });

    mobileMenu.querySelectorAll('a').forEach((a) => {
      a.addEventListener('click', () => {
        hamburger.classList.remove('is-open');
        mobileMenu.classList.remove('is-open');
        body.classList.remove('no-scroll');
        hamburger.setAttribute('aria-expanded', 'false');
        mobileMenu.setAttribute('aria-hidden', 'true');
      });
    });
  }
})();
